<script>
  import ListHeader from '../../../../components/list/Header.vue'
  import * as restfulService from '../../../../services/restfulService'
  import bus from '@utils/bus'

  export default {
    components: {ListHeader},
    props: ['event'],
    data () {
      return {
        isLoadingData: true,
        registrations: [],
        papers: []
      }
    },
    mounted () {
      const id = this.event.id || null
      // const mainEventId = this.event.event_id || null
      if (id) {
        bus.$emit('show-loader')
        Promise.all([
          this.loadRegistrations(id),
          this.loadPapers(id)
        ]).then(_ => {
          this.isLoadingData = false
          bus.$emit('hide-loader')
        }).catch(reason => {
          console.warn('Erro ao buscar!', reason)
        })
      }
    },
    methods: {
      loadRegistrations (id) {
        return new Promise((resolve, reject) => {
          let searchData = {
            'modalities.event_modality': {has: [{event_id: id}]},
            orderBy: [
              {
                column: 'created_at',
                direction: 'DESC'
              }
            ]
          }
          restfulService.search('registration', null, searchData, null, ['person', 'status'], 1, 10)
            .then(response => {
              this.registrations = response.data
              resolve()
            })
            .catch((err) => {
              console.log(err)
              reject(err)
            })
        })
      },
      loadPapers (id) {
        return new Promise((resolve, reject) => {
          let searchData = {
            'registration.modalities.event_modality': {has: [{event_id: id}]},
            orderBy: [
              {
                column: 'date_submitted',
                direction: 'DESC'
              }
            ]
          }
          restfulService.search('paper', null, searchData, null, ['registration.person', 'status', 'contents'], 1, 10)
            .then(response => {
              this.papers = response.data
              resolve()
            })
            .catch((err) => {
              console.log(err)
              reject(err)
            })
        })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <el-row :gutter="20">
            <el-col :span="12">
                <h3>Últimas Inscrições</h3>
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Pessoa</th>
                        <th>Data da Inscrição</th>
                        <th>Instituição</th>
                        <th>Status da Inscrição</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in registrations">
                        <td>{{item.person.pessoa.id}} - {{item.person.pessoa.nome}}</td>
                        <td>{{item.created_at | dateTimeEnToBr}}</td>
                        <td>{{item.institution.name}}</td>
                        <td>{{item.status.name}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="12">
                <h3>Últimas Submissões</h3>
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Autor</th>
                        <th>Data da Submissão</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in papers">
                        <td>
                            {{item.registration.person.ref_pessoa}} - {{item.registration.person.pessoa.nome}}
                        </td>
                        <td>{{item.date_submitted | dateTimeEnToBr}}</td>
                        <td>{{item.status.name}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>
    </div>
</template>



// WEBPACK FOOTER //
// Home.vue?fb2913d6